var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedcross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{display:none;}\r\n    .st1{display:inline;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n    .st2{fill:#FF0000;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n    .st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 11.1,
    cy: 11.1,
    rx: 10.6,
    ry: 10.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000070084925710013193820000009044545370121898904_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_00000021806548415452298890000011656047308562800261_",
    className: "st0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.1,12.5L18,8.7c0.5-0.5,0.5-1.2,0-1.7s-1.2-0.5-1.7,0l-3.8,3.8L8.7,7C8.3,6.6,7.5,6.6,7.1,7             c-0.5,0.5-0.5,1.2,0,1.7l3.7,3.8L7,16.2c-0.5,0.5-0.5,1.2,0,1.7c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3l3.8-3.7l3.8,3.8             c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3c0.5-0.5,0.5-1.2,0-1.7L14.1,12.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcross);
export default __webpack_public_path__ + "static/media/redcross.2bfc0df72f499c8fc199591f1a0cee26.svg";
export { ForwardRef as ReactComponent };